import axios from '../../axios';
import { getLogger } from '../../logging';
const logger = getLogger('AppRegistryService');
class AppRegistryService {
  // TODO: Init by making call to AppRegistry Service root

  async getAvailableApps() {
    let availableApplications = [];
    try {
      const data = await this.fetchApps();
      if (data && data.items) {
        availableApplications = this.createAppTreeModel(data.items);
      }
    } catch (err) {
      // Log error - unable to retrieve available applications
    }
    return availableApplications;
  }
  async fetchApps() {
    const url = '/appRegistry/applications/applicationTree';
    const response = await this.doGet(url);
    return response.data;
  }
  async doGet(url) {
    const response = await axios.get(url);
    return response;
  }
  createAppTreeModel(dataItems) {
    const appTreeModel = [];
    for (const item of dataItems) {
      appTreeModel.push(this.createNode(item));
    }
    return appTreeModel;
  }
  createNode(item) {
    if (item.branch === true) {
      return this.createBranchNode(item);
    }
    return this.createLeaf(item);
  }
  createBranchNode(item) {
    const children = [];
    for (const child of item.children) {
      children.push(this.createLeaf(child));
    }
    const branch = {
      children,
      id: item.id,
      label: item.label
    };
    return branch;
  }
  createLeaf(item) {
    const leaf = {
      appId: item.appId,
      appName: item.appName,
      appSwitcherCompliance: item.appSwitcherCompliance,
      createDefaultShortcut: item.createDefaultShortcut,
      directiveId: item.id,
      hidden: item.hidden,
      label: item.label,
      shortcutLabel: item.shortcutLabel,
      specialRole: item.specialRole,
      uri: item.uri,
      favoriteUri: item.links?.find(link => link.rel === 'addFavorite' || link.rel === 'removeFavorite')?.uri
    };
    return leaf;
  }
  async getPublicTypeSupportingApps() {
    let types = new Map();
    try {
      const data = await this.fetchTypes();
      if (data && data.items) {
        types = this.createTypesModel(data.items);
      }
    } catch (err) {
      // Log error - unable to retrieve types
    }
    return types;
  }
  async fetchTypes() {
    const url = '/appRegistry/types';
    const response = await this.doGet(url);
    return response.data;
  }
  createTypesModel(items) {
    const types = new Map();
    for (const item of items) {
      types.set(item.id, this.createTypeApps(item.apps));
    }
    return types;
  }
  createTypeApps(apps) {
    const typeApps = [];
    for (const app of apps) {
      const typeApp = {
        appId: app.appId,
        directiveId: app.directive,
        verbLabel: app.targetVerbLabel,
        verbCode: app.targetVerbCode
      };
      typeApps.push(typeApp);
    }
    return typeApps;
  }
  favoritesUrl = '/appRegistry/applications/favorites';
  async updateFavorites(directives) {
    try {
      await axios.put(this.favoritesUrl, directives, {
        headers: {
          Accept: 'application/vnd.sas.collection+json',
          'Content-Type': 'application/vnd.sas.collection+json'
        }
      });
    } catch (err) {
      logger.error('Unable to update favorited applications');
    }
  }
  async addFavorite(favoriteUri) {
    try {
      await axios.put(favoriteUri, {
        headers: {
          Accept: 'application/vnd.sas.app.registry.favorite+json'
        }
      });
    } catch (err) {
      logger.error('Unable to add to favorited applications');
    }
  }
  async removeFavorite(favoriteUri) {
    try {
      await axios.delete(favoriteUri);
    } catch (err) {
      logger.error('Unable to remove from favorited applications');
    }
  }
}
export default AppRegistryService;
//# sourceMappingURL=AppRegistryService.js.map